import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }



export const updateAnswerOptionAction = createAsyncThunk(
    'update--answer-option',
    async (data = null, { rejectWithValue }) => {
        try {
            const res = await axios.patch(`/support-server/api/update--answer-option`, { ...data })
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const updateAnswerOptionSlice = createSlice({
    name: 'update-answer-option',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(updateAnswerOptionAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(updateAnswerOptionAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(updateAnswerOptionAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const updateAnsweroptionReducer = updateAnswerOptionSlice.reducer